import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const e=l("chat_bubble",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 4.88854V17.7959H5.17L4 19.0544V4.88854H20ZM20 2.7373H4C2.9 2.7373 2 3.70536 2 4.88854V21.6574C2 22.6147 3.08 23.0987 3.71 22.4211L6 19.9471H20C21.1 19.9471 22 18.9791 22 17.7959V4.88854C22 3.70536 21.1 2.7373 20 2.7373Z"
                fill="#FCFCFC" />
        </svg>
    `),w=l("chat_bubble_filled",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 2.7373H4C2.9 2.7373 2 3.6373 2 4.7373V22.7373L6 18.7373H20C21.1 18.7373 22 17.8373 22 16.7373V4.7373C22 3.6373 21.1 2.7373 20 2.7373Z"
                fill="#FCFCFC" />
        </svg>
    `);export{e as ChatBubble,w as ChatBubbleFilled};
